/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { CreditCard, creditCardTypeString } from "../../concept/subscription";

@Pipe({
    name: "creditCardType",
    standalone: true,
})
export class CreditCardTypePipe implements PipeTransform {
    transform(card: CreditCard): string {
        return creditCardTypeString(card);
    }
}
